import { AppAction } from 'actions/types/ActionTypes'

function submitLoyaltyPointsEarnCalculationRequest(
  _calculationRequest: App.LoyaltyPointsEarnCalculationRequest,
): AppAction {
  return () => {
    return null
  }
}

export default submitLoyaltyPointsEarnCalculationRequest
